import React from 'react';
import {Form} from "semantic-ui-react";
import {PaymentDetails} from "./PaymentDetailsContainer";
import StripeField from "./stripeField";
import {isAnsel} from '../../utils/common';
import UseDifferentPaymentMethod from "./useDifferentPaymentMethod";
import {CardCvcElement, CardExpiryElement, CardNumberElement} from "@stripe/react-stripe-js";
import StripePaymentError from "./stripePaymentError";

const CheckoutForm = ({strings, YourCost}) => {
    const {
        hideCreditCardPm,
        setIsCcCardNumberEmpty,
        setIsCcExpirationEmpty,
        setIsCcCVCEmpty,
        setCcInputError,
        ccInputError,
    } = PaymentDetails.useContainer();

    return (
        <Form>
            <StripePaymentError strings={strings} paymentMethod={strings.creditCard} />
            <p className={"primaryHeaderColor"} style={{margin: "0 0 15px"}}><b>{strings.creditCard}</b></p>
            <StripeField label={strings.cardNumber} component={CardNumberElement} setIsEmpty={setIsCcCardNumberEmpty} setCcInputError={setCcInputError}/>
            <Form.Group widths="equal" style={{alignItems: "end"}}>
                <StripeField label={strings.expiration} component={CardExpiryElement} setIsEmpty={setIsCcExpirationEmpty} setCcInputError={setCcInputError} />
                <StripeField label={strings.cvc} component={CardCvcElement} setIsEmpty={setIsCcCVCEmpty} setCcInputError={setCcInputError}/>
            </Form.Group>
            {isAnsel() && ccInputError.cardExpiry.error.customError && (<p className='errorLabel'>{ccInputError.cardExpiry.error.customError}</p>)}
            { YourCost }
            <UseDifferentPaymentMethod hideMethod={hideCreditCardPm} strings={strings} />
        </Form>
    );
}

export default CheckoutForm;
